var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseShareholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3851 1.63476C11.3851 1.37341 11.2813 1.12276 11.0965 0.937962C10.9117 0.753161 10.661 0.649341 10.3997 0.649341C10.1383 0.649341 9.88769 0.753161 9.70288 0.937963L6.01709 4.62376L2.3313 0.937963C2.14649 0.753161 1.89585 0.649341 1.6345 0.649341C1.37315 0.649341 1.12251 0.753161 0.937706 0.937962C0.752905 1.12276 0.649084 1.37341 0.649084 1.63476C0.649084 1.89611 0.752905 2.14675 0.937706 2.33155L4.6235 6.01735L0.937707 9.70314C0.752905 9.88794 0.649084 10.1386 0.649084 10.3999C0.649084 10.6613 0.752905 10.9119 0.937706 11.0967C1.12251 11.2815 1.37315 11.3854 1.6345 11.3854C1.89585 11.3854 2.14649 11.2815 2.3313 11.0967L6.01709 7.41094L9.70288 11.0967C9.88769 11.2815 10.1383 11.3854 10.3997 11.3854C10.661 11.3854 10.9117 11.2815 11.0965 11.0967C11.2813 10.9119 11.3851 10.6613 11.3851 10.3999C11.3851 10.1386 11.2813 9.88794 11.0965 9.70314L7.41068 6.01735L11.0965 2.33155C11.2813 2.14675 11.3851 1.89611 11.3851 1.63476Z",
    fill: "#4F4F4F",
    stroke: "#4F4F4F",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseShareholder);
export default __webpack_public_path__ + "static/media/close-shareholder.359b051703afc43beffb1b06b96e163e.svg";
export { ForwardRef as ReactComponent };